// schemas.js
const medicalOrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalOrganization",
  name: "Whistle",
  url: "https://whistle.in/",
  logo: "https://whistle.in/images/logo.svg",
  description:
    "Whistle provides high-quality orthodontic care specializing in invisible braces and clear teeth aligners.",
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "Third Floor, Eldeco Centre, Block A, MRTS Station, Malviya Nagar",
    addressLocality: "New Delhi",
    addressRegion: "Delhi",
    postalCode: "110017",
    addressCountry: "India",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "18003095252",
    contactType: "customer service",
    availableLanguage: ["English"],
  },
  sameAs: [
    "https://www.facebook.com/Whistle.india.in//",
    "https://x.com/whistleindia_in",
    "https://in.linkedin.com/company/whistle-india-in",
  ],
};

const dentistSchema = {
  "@context": "https://schema.org",
  "@type": "Dentist",
  name: "Whistle - Vasant Kunj",
  url: "https://whistle.in/location/Vasant-Kunj",
  logo: "https://whistle.in/path-to-your-logo.png",
  description:
    "Whistle's Vasant Kunj location provides professional orthodontic care with services like invisible braces and clear aligners.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Specific Address Not Listed",
    addressLocality: "Vasant Kunj",
    addressRegion: "New Delhi",
    postalCode: "Postal Code",
    addressCountry: "IN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "1800-309-5252",
    contactType: "customer service",
    availableLanguage: ["English"],
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "09:00",
      closes: "18:00",
    },
  ],
  sameAs: [
    "https://www.facebook.com/Whistle.india.in//",
    "https://x.com/whistleindia_in",
  ],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What services does Whistle offer?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Whistle specializes in orthodontic care, offering invisible braces and clear aligners tailored to individual needs.",
      },
    },
    {
      "@type": "Question",
      name: "How does Whistle ensure the quality of its aligners?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Whistle's aligners are custom-made using advanced technology and are monitored by licensed orthodontists throughout the treatment process.",
      },
    },
    {
      "@type": "Question",
      name: "How can I book a consultation with Whistle?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "You can book a consultation through the Whistle website or contact their customer service at 1800-309-5252.",
      },
    },
    {
      "@type": "Question",
      name: "Where is Whistle located?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Whistle has locations in various cities, including New Delhi, with a branch in Vasant Kunj.",
      },
    },
  ],
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "About Us - Whistle",
  url: "https://whistle.in/about-us",
  description:
    "Learn about Whistle, a provider of premium orthodontic care specializing in invisible braces and clear aligners.",
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://whistle.in/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "About Us",
        item: "https://whistle.in/about-us",
      },
    ],
  },
  isPartOf: {
    "@type": "WebSite",
    name: "Whistle",
    url: "https://whistle.in/",
  },
  about: {
    "@type": "Thing",
    name: "Orthodontic Care and Aligners",
  },
};
const BreadCrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://whistle.in/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Blog",
      item: "https://whistle.in/blog/",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Aligners",
      item: "https://whistle.in/blog/aligners/",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Braces vs Clear Aligners",
      item: "https://whistle.in/blog/aligners/braces-vs-clear-aligners",
    },
  ],
};
const brandSchema = {
  "@context": "https://schema.org",
  "@type": "Brand",
  name: "Whislte",
  url: "https://whistle.in",
  logo: "https://whistle.in/images/logo.svg",
  description:
    "Discover Whistle, a trusted dental care brand with 750+ clinics across India. Specializing in custom teeth aligners,teeth braces and dental crowns, we bring expert solutions for your perfect smile.  Experience advanced, accessible, and affordable dental care with Whistle.",
  sameAs: [
    "https://www.facebook.com/Whistle.india.in//",
    "https://x.com/whistleindia_in",
    "https://in.linkedin.com/company/whistle-india-in",
  ],
  slogan: "Whistle: India's Trusted Brand for Teeth Aligners, Braces & Dental Crowns",
  // aggregateRating: {
  //   "@type": "AggregateRating",
  //   ratingValue: "4.9",
  //   reviewCount: "125",
  // },
};


const homepageProductSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Whistle Clear Aligners",
  description: "Invisible clear aligners for teeth straightening.",
  brand: {
    "@type": "Brand",
    name: "Whistle",
  },
  url: "https://whistle.in/",
  offers: {
    "@type": "Offer",
    priceCurrency: "INR",
    availability: "https://schema.org/InStock",
  },
};

const homepageBlogSchema = {
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "Whistle Blog",
  url: "https://whistle.in/",
  publisher: {
    "@type": "Organization",
    name: "Whistle",
  },
};

const homepageReviewSchema = {
  "@context": "https://schema.org",
  "@type": "Review",
  reviewRating: {
    "@type": "Rating",
    ratingValue: "5",
    bestRating: "5",
  },
  author: {
    "@type": "Person",
    name: "Customer",
  },
  itemReviewed: {
    "@type": "Product",
    name: "Whistle Clear Aligners",
  },
};

const teethBracesFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What are teeth braces used for?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Teeth braces are used to straighten misaligned teeth, fix bite issues, and improve overall dental alignment.",
      },
    },
    {
      "@type": "Question",
      name: "How long does braces treatment take?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Braces treatment usually takes between 12 to 24 months depending on the dental condition and treatment plan.",
      },
    },
    {
      "@type": "Question",
      name: "Are braces painful?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Braces may cause mild discomfort for a few days after adjustments, but the treatment is generally manageable.",
      },
    },
    {
      "@type": "Question",
      name: "What types of braces are available?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Common types of braces include metal braces, ceramic braces, self-ligating braces, and clear aligners.",
      },
    },
    {
      "@type": "Question",
      name: "Can adults get braces treatment?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, braces treatment is suitable for both teenagers and adults depending on their orthodontic needs.",
      },
    },
  ],
};

const glowReviewSchema = {
  "@context": "https://schema.org",
  "@type": "Review",
  author: {
    "@type": "Person",
    name: "Whistle Customer",
  },
  reviewBody:
    "The glow treatment experience was smooth and professionally managed with noticeable smile enhancement results.",
  reviewRating: {
    "@type": "Rating",
    ratingValue: 4.8,
    bestRating: 5,
  },
  itemReviewed: {
    "@type": "Organization",
    name: "Whistle",
  },
};

const blogCollectionPageSchema = {
    
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Whistle Blog",
  "url": "https://whistle.in/blog/",
  "description": "Explore dental care, braces, aligners, and smile transformation related articles by Whistle."

};
const alignerCollectionPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Aligners Blog",
  "url": "https://whistle.in/blog/aligners/",
  "description": "Read articles and guides related to clear aligners, invisible braces, and orthodontic treatments."
};
const bracesCollectionPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Braces Blog",
  "url": "https://whistle.in/blog/braces",
  "description": "Explore braces treatment information, dental alignment tips, and orthodontic care articles."
};
const gdCollectionPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "General Orthodontist Blog",
  "url": "https://whistle.in/blog/general-orthodontist",
  "description": "Discover orthodontic treatment guides, dental health insights, and smile correction related content."
};
const glowCollectionPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Glow Blog",
  "url": "https://whistle.in/blog/glow",
  "description": "Read articles about smile enhancement, dental aesthetics, and glow treatment solutions."
};
const treatmentCollectionPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Whistle Treatment Pages",
  "url": "https://whistle.in/treatment/",
  "description": "Explore orthodontic and dental treatment solutions including aligners, braces, and smile correction treatments."
};
const alignerCostPageSchema = {
  "@context": "https://schema.org",
  "@type": "Review",
  "author": {
    "@type": "Person",
    "name": "Whistle Customer"
  },
  "reviewBody": "The aligners treatment pricing was transparent and the overall treatment experience was comfortable and effective.",
  "reviewRating": {
    "@type": "Rating",
    "ratingValue": 4.8,
    "bestRating": 5
  },
  "itemReviewed": {
    "@type": "Service",
    "name": "Whistle Aligners Cost",
    "provider": {
      "@type": "Organization",
      "name": "Whistle"
    }
  }
};
const teethBracesCostPageSchema = {
  "@context": "https://schema.org",
  "@type": "Review",
  "author": {
    "@type": "Person",
    "name": "Whistle Customer"
  },
  "reviewBody": "The aligners treatment pricing was transparent and the overall treatment experience was comfortable and effective.",
  "reviewRating": {
    "@type": "Rating",
    "ratingValue": 4.8,
    "bestRating": 5
  },
  "itemReviewed": {
    "@type": "Service",
    "name": "Whistle Aligners Cost",
    "provider": {
      "@type": "Organization",
      "name": "Whistle"
    }
  }
};

export {
  medicalOrganizationSchema,
  dentistSchema,
  faqSchema,
  webPageSchema,
  BreadCrumbSchema,
  brandSchema,
  homepageProductSchema,
  homepageBlogSchema,
  homepageReviewSchema,
  teethBracesFaqSchema,
  glowReviewSchema,
  blogCollectionPageSchema,
  alignerCollectionPageSchema,
  bracesCollectionPageSchema,
  gdCollectionPageSchema,
  glowCollectionPageSchema,
  alignerCostPageSchema,
  teethBracesCostPageSchema,
  treatmentCollectionPageSchema
};
